import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Components/Footer/Footer";
import Navbar from "../Components/Navbar/Navbar";

const Main = () => {
  // bg-gradient-to-r from-indigo-500 to-blue-500
  // bg-gradient-to-r from-blue-800 to-indigo-900
  // bg-gradient-to-r from-violet-600 to-indigo-600
  return (
    <div className="bg-gradient-to-r from-blue-800 to-indigo-900 min-h-screen">
      <Navbar></Navbar>
      <Outlet></Outlet>
      <Footer></Footer>
    </div>
  );
};

export default Main;
